import { Descriptions } from 'antd';
import { FormatDate } from '../../../../../../constants';
import 'react-json-view-lite/dist/index.css';
import { CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1FieldsFragment } from '../../../../../../generated';

interface DecisionDetailProps {
  isArchived?: boolean;
  data: CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1FieldsFragment;
}

export const DecisionDetail: React.FC<DecisionDetailProps> = (props) => {

  return (
    <div className="mt-2">
      <Descriptions layout="vertical" column={6}>
        <Descriptions.Item label="Decision Date">{FormatDate(props.data.applicationReview?.decision?.completedAt)}</Descriptions.Item>
        <Descriptions.Item label="Decision">{props.data.applicationReview?.decision?.result}</Descriptions.Item>
        <Descriptions.Item label="Approval By">{props.data.applicationReview?.decision?.completedBy ? props.data.applicationReview?.decision?.completedBy?.displayName : "SYSTEM"}</Descriptions.Item>
      </Descriptions>
    </div>
  );
};
